import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

interface UseGetVendorFinancialInfoByVendorIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorFinancialInfoByVendorId = async (id: string) =>
  await axiosAuth.get(`${VENDORS}/${id}/financial-details`);

const useGetVendorFinancialInfoByVendorId = ({
  id,
  queryParams,
}: UseGetVendorFinancialInfoByVendorIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-finance", id],
    queryFn: () => getVendorFinancialInfoByVendorId(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetVendorFinancialInfoByVendorId;
